import { Money } from "v-money";
import { mapActions, mapState } from "vuex";

import AppPagarComissaoDialog from "./dialogs/PagarComissaoDialog.vue";
import AppAdicionarComissaoDialog from "./dialogs/AdicionarComissaoDialog.vue";
import AppPagarComissaoCompletaDialog from "./dialogs/PagarComissaoCompletaDialog.vue";
import AppAdicionarPagamentoComissaoDialog from "./dialogs/AdicionarPagamentoComissaoDialog.vue";

import AppGravarClienteDialog from "../../shared/dialogs/GravarClienteDialog.vue";
import AppCriarDiretorioDialog from "../../shared/dialogs/CriarDiretorioDialog.vue";
import AppSelecionarDiretorioDialog from "../../shared/dialogs/SelecionarDiretorioDialog.vue";
import AppPerguntasFormularioDialog from "../../shared/dialogs/PerguntasFormularioDialog.vue";
import AppUploadArquivoDialog from "../../shared/dialogs/UploadArquivoDialog.vue";
import AppGravarObservacaoDialog from "../../shared/dialogs/GravarObservacaoDialog.vue";
import AppCriarDiretorioArquivoDialog from "../../shared/dialogs/CriarDiretorioArquivoDialog.vue";
import AppSelecionarDiretorioArquivoDialog from "../../shared/dialogs/SelecionarDiretorioArquivosDialog.vue";  

import Util from "../../util/funcoes.js";
import { STATUS_PAGAMENTO, STATUS_CONTRATO, BANCOS, ESTADOS } from "../../util/constantes.js";

var BigDecimal = require("js-big-decimal");

export default {
  components: {
    AppPagarComissaoDialog,
    AppAdicionarComissaoDialog,
    AppPagarComissaoCompletaDialog,
    AppAdicionarPagamentoComissaoDialog,

    AppCriarDiretorioDialog,
    AppSelecionarDiretorioDialog,
    AppPerguntasFormularioDialog,
    AppUploadArquivoDialog,
    AppGravarClienteDialog,
    AppGravarObservacaoDialog,
    AppCriarDiretorioArquivoDialog,
    AppSelecionarDiretorioArquivoDialog,

    Money
  },
  data() {
    return {
      infiniteLoadingId: 0,

      tabKey: 0,
      tabSelecionada: "detalhes",
      loadingUsuarios: false,
      loadingClientes: false,
      loadingImoveis: false,

      observacaoSelecionada: {},
      observacaoEmEdicao: undefined,
      formularioSelecionado: {
        perguntasFormulario: []
      },
      comissaoSelecionada: {
        corretor: {
          nome: ""
        }
      },
      historicoComissaoSelecionada: {
        corretor: {
          nome: ""
        }
      },

      filtroObservacoes: '',
      
      visibilidadeDialogAdicionarComissao: false,
      visibilidadeDialogPagarComissao: false,
      visibilidadeDialogPagarComissaoCompleta: false,
      visibilidadeDialogAdicionarPagamentoComissao: false,
      visibilidadeDialogCancelarPagamentoComissao: false,
      visibilidadeDialogRemoverPagamentoComissao: false,

      visibilidadeCriarDiretorioDialog: false,
      visibilidadeSelecionarDiretorioDialog: false,
      visibilidadePerguntasFormularioDialog: false,
      visibilidadeUploadArquivoDialog: false,
      visibilidadeGravarClienteDialog: false,
      visibilidadeGravarObservacaoDialog: false,
      visibilidadeCriarDiretorioDialogArquivo: false,
      visibilidadeSelecionarDiretorioArquivoDialog: false,

      comissaoImobiliaria: false,
      comissaoRestante: 0,
      percentualRestante: 0,

      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false
      },

      /*moneyWithPrefix: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
        prefix: "R$ "
      },*/

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      },

      contasBancaria: [{
        id: 0,
        nome: ''
      }],

      permissoes: {},

      defaultProps: {
        label: "nome",
        children: "formularios"
      },

      validacao: {
        dataVenda: [{ required: true, len: 10 }],
        imovel: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        cliente: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        usuario: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1 }
            }
          }
        ],
        valor: [{ type: "number", min: 1 }],
        // comissao: [{ type: "number", min: 0.01, max: 100 }]
      },

      arquivoSelecionado: undefined,
      arquivosProps: {
        label: "nome",
        children: "arquivos"
      },
      keysArquivo: ["usuario","descricao","data","localizacaoFisica", "extensao"],


      percentualComissaoIsSelecionado: true,

      hoverGravar: false,
      hoverAprovar: false,
      hoverDesaprovar: false,
      hoverFinalizar: false,
      hoverCancelar: false,
      hoverRemover: false,
      hoverRestaurar: false,
    };
  },
  created() {    
    this.usuarioLogado.permissoes.forEach(item => {
      if (item.modulo === "CONTRATOS_VENDA") {
        this.permissoes = item;
      }
    });

    if(this.vendaNova) this.configurarCampoCorretor();
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado; }
    }),
    ...mapState("vendasContratosStore", {
      venda(state) { return state.vendaSelecionada; },
      vendas(state) { return state.listaVendas; },
      arquivos(state){ return state.vendaSelecionada.diretorios},
      vendaPesquisa(state) { return state.vendaPesquisa; },
      logs(state) { return state.logs; },
      formularios(state) { return state.formularios; },
      labelQuantidade(state) {return state.labelQuantidade},
      dadosPesquisaVenda() {
        return (
          this.vendaPesquisa.status != "" ||
          this.vendaPesquisa.dataVendaInicio != "" ||
          this.vendaPesquisa.dataVendaFim != "" ||
          this.vendaPesquisa.imovel.idNaImobiliaria != "" ||
          this.vendaPesquisa.cliente.nome != ""
        )
      }
    }),
    //PESQUISA
    status() {
      return STATUS_CONTRATO;
    },
    loading() {
      return this.$store.state.loading;
    },
    //ARQUIVOS
    linhasArquivo(){
      if(this.arquivoSelecionado){
        return Object.entries(this.arquivoSelecionado)
        .filter(([key]) => this.keysArquivo.includes(key) )
        .map(([key,value]) => ({key, value})).sort((a, b ) => {
          if(a.key === "localizacaoFisica"){
            return 1
          }
          if(b.key === "localizacaoFisica"){
            return -1
          }
        })
      }      
    },

    //CADASTRO
    usuariosDisponiveis() {
      return this.$store.state.vendasContratosStore.usuariosDisponiveis;
    },
    clientesDisponiveis() {
      return this.$store.state.vendasContratosStore.clientesDisponiveis;
    },
    imoveisDisponiveis() {
      return this.$store.state.vendasContratosStore.imoveisDisponiveis;
    },
    vendaNova() {
      return this.venda.id == 0;
    },
    disableAlteracao() {
      return this.venda.id != 0;
    },
    statusPagamento() {
      return STATUS_PAGAMENTO;
    },
    observacoesFiltradas() {
      return this.venda.observacoesDosUsuarios
        .filter(this.filtrarObservacoes);
    },
    util() {
      return Util;
    },
    exibirBotaoNovo() {
      return ( this.permissoes.cadastro );
    },
    exibirBotaoNovoCliente() {
      return (
        this.venda.id == 0
      );
    },
    exibirBotaoUploadArquivo() {
      return this.tabSelecionada == "arquivos";
    },
    exibirBotaoGravar() {
      return (
        (this.permissoes.cadastro &&
          this.venda.id === 0) ||
        (this.permissoes.alteracao &&
          this.venda.id !== 0 &&
          this.venda.status === "PENDENTE")
      );
    },
    exibirBotaoCriarDiretorio() {
      return (
        this.permissoes.geracaoFormularios &&
        this.tabSelecionada == "formularios"
      );
    },
    exibirBotaoGerarFormulario() {
      return (
        this.permissoes.geracaoFormularios &&
        this.tabSelecionada == "formularios" &&
        this.formularioSelecionado.nomeArquivo
      );
    },
    exibirBotaoRemover() {
      return (
        this.permissoes.remocao &&
        (this.venda.status === "PENDENTE" || "CANCELADO") &&
        this.venda.id !== 0
        
      );
    },

    exibirBotaoRestaurar() {
      return (
        this.permissoes.alteracao &&
        this.venda.status === "CANCELADO" &&
        this.venda.id !== 0
      );
    },
    exibirBotaoAprovar() {
      return (
        this.permissoes.alteracao &&
        this.venda.status === "PENDENTE" &&
        this.venda.id !== 0
      );
    },
    exibirBotaoDesaprovar() {
      return (
        this.permissoes.alteracao &&
        this.venda.status === "APROVADO" &&
        this.venda.id !== 0
      );
    },
    exibirBotaoCancelar() {
      return (
        this.permissoes.alteracao &&
        this.venda.status === "APROVADO" &&
        this.venda.id !== 0
      );
    },
    exibirBotaoAdicionarComissao() {
      if (this.tabSelecionada == "detalhes" && this.venda.id === 0) {
        return true;
      } else if (
        this.tabSelecionada == "detalhes" &&
        this.venda.status === "PENDENTE" &&
        this.venda.id !== 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    exibirBotaoGerarRecibosPagos() {
      return (
        this.comissaoSelecionada !== undefined &&
        this.comissaoSelecionada.id !== undefined &&
        this.comissaoSelecionada.id !== 0 &&
        !this.comissaoSelecionada.comissaoImobiliaria
      );
    },
    exibirBotaoPagarComissaoCompleta() {
      return (
        this.venda.status === "APROVADO" &&
        this.comissaoSelecionada !== undefined &&
        this.comissaoSelecionada.id !== undefined &&
        this.comissaoSelecionada.id !== 0 &&
        this.comissaoSelecionada.valorEmAberto !== 0
      );
    },
    exibirBotaoAdicionarPagamento() {
      return (
        this.venda.status === "APROVADO" &&
        this.comissaoSelecionada !== undefined &&
        this.comissaoSelecionada.id !== undefined &&
        this.comissaoSelecionada.id !== 0 &&
        this.comissaoSelecionada.valorEmAberto !== 0
      );
    },
    exibirBotaoGerarListaComissoes() {
      return (
        this.venda.status === "APROVADO" 
      );
    },
    exibirBotaoGerarRecibo() {
      return (
        this.historicoComissaoSelecionada !== undefined &&
        this.historicoComissaoSelecionada.id !== 0 &&
        this.historicoComissaoSelecionada.status === "PAGO" &&
        this.historicoComissaoSelecionada.corretor.id !== 0
      );
    },
    exibirBotaoCancelarPagamento() {
      return (
        this.venda.status === "APROVADO" &&
        this.historicoComissaoSelecionada !== undefined &&
        this.historicoComissaoSelecionada.id !== 0 &&
        this.historicoComissaoSelecionada.status === "PAGO"
      );
    },
    exibirBotaoPagarPagamento() {
      return (
        this.venda.status === "APROVADO" &&
        this.historicoComissaoSelecionada !== undefined &&
        this.historicoComissaoSelecionada.id !== 0 &&
        this.historicoComissaoSelecionada.status === "EM_ABERTO"
      );
    },
    exibirBotaoGerarRelatorioObservacao() {
      return this.venda.id != 0 && this.tabSelecionada == "observacoes";
    },
    exibirColunaRemoverObservacao() {
      return this.permissoes.removerObservacoes;
    },
    disableCampoAtendente() {
      return !this.permissoes.alteracaoCorretor;
    }
  },  
  watch: {
    vendaNova(newValue) {
      if (newValue) {
        this.tabSelecionada = "detalhes";
        this.tabKey++;
      }
    },
    "venda.id": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.tabSelecionada = "detalhes";
        this.configurarDataGridComissoes();
        this.configurarHistoricoPagamentoComissoes();
        this.observacaoSelecionada = {};
      }
    },
    "venda.valor": function(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== 0) {
        this.calcularComissao()
      }
    }
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("loginStore", [
      "validarAcesso"
    ]),
    ...mapActions("vendasClientesStore", [
      "recuperarClienteVenda"
    ]),
    ...mapActions("vendasContratosStore", [
      "limparVendaPesquisa",
      "limparVendasListadas",
      
      "aprovarVenda",
      "cancelarPagamentoComissao",
      "desaprovarVenda",
      "cancelarVenda",
      "restaurarVenda",
      "gerarFormularioVenda",
      "gerarReciboComissaoPagos",
      "gerarReciboComissaoUnico",
      "gravarVenda",
      "listarClientes",
      "listarImoveis",
      "listarUsuarios",
      "listarVendas",
      "novaVenda",
      "recuperarFormularios",
      "recuperarLogs",
      "recuperarObservacaoVenda",
      "recuperarPerguntasFormulario",
      "recuperarVenda",
      "removerArquivo",
      "removerDiretorioVenda",
      "removerObservacao",
      "removerPagamentoComissao",
      "removerVenda",
      "removerDiretorioArquivos",
      "verificarAprovacaoVenda"
    ]),
    ...mapActions('vendasRelatoriosStore', [
      'gerarRelatorio'
    ]),

    //PESQUISA
    formatarLinha1Endereco(imovel) {
      return imovel.endereco + (imovel.numeroEndereco ? ", " + imovel.numeroEndereco : "");
    },
    formatarLinha2Endereco(imovel) {
      return imovel.condominio &&
        imovel.condominio.nome
        ? imovel.condominio.nome +
            " - " +
            imovel.bairro.nome +
            " - " +
            imovel.cidade.nome
        : imovel.bairro.nome + " - " + imovel.cidade.nome;
    },
    novo() {
      this.novaVenda();
      this.configurarCampoCorretor();
    },

    pesquisarHandler() {
      this.vendaPesquisa.pagina = 0;
      this.limparVendasListadas();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if(this.vendaPesquisa.pagina == 0) { this.showLoading(); }

      this.listarVendas(this.vendaPesquisa)
      .then((resultado) => {
        if(this.vendaPesquisa.pagina == 0) { this.hideLoading(); }
        
        if(resultado.lista.length == 100) {
          this.vendaPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.vendaPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      });
    },
    limparPesquisa() {
      this.limparVendaPesquisa();
    },
    recuperar(vendaSelecionada) {
      this.irParaSecao()
      let payload = { id: vendaSelecionada.id };

      this.showLoading();
      this.recuperarVenda(payload)
      .then(() => {
        this.hideLoading();
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },

    //CADASTRO
    verificarAprovacao() {
      this.showLoading();
      this.verificarAprovacaoVenda(this.venda)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            if(resultado.mensagem.includes('Deseja continuar mesmo assim?')){
              this.$confirm(resultado.mensagem, "Atenção", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
                type: "warning"
              }).then(() => {
                this.aprovarHandler()
              });
            } else {
              this.$message.warning(resultado.mensagem);
              this.pesquisarHandler();
            }
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },

    aprovarHandler() {
      this.showLoading();
      this.aprovarVenda(this.venda)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    desaprovarHandler() {
      this.showLoading();
      this.desaprovarVenda()
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    cancelarHandler() {
        this.$confirm("Deseja cancelar esta Venda?", "Atenção", {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning"
        }).then(() => {
          this.cancelar();
        }); 
    },

    restaurarHandler() {
        this.$confirm("Desfazer cancelamento da Venda?", "Atenção", {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning"
        }).then(() => {
          this.restaurar();
        });    
    },

    restaurar() {
      this.showLoading();
      this.restaurarVenda()
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },

    cancelar() {
      this.showLoading();
      this.cancelarVenda()
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          default:
            this.$message.warning(resultado.mensagem);
        }
        this.hideLoading();
      })
      .catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
        this.hideLoading();
      });
    },
    gravarHandler() {
      this.$refs["formVenda"].validate(valid => {
        if(valid && this.venda.comissoes.length > 0 && this.percentualRestante == 0) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios e complete as comissões");
        }
      });
    },
    gravar() {
      let payload = this.venda;
      this.venda.status = 'PENDENTE';
      this.showLoading();
      this.gravarVenda(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
    },

    removerVendaSelecionada(){
      let payload = { id: this.venda.id };
      
      this.showLoading();
      this.removerVenda(payload)
      .then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.$message.error("Ocorreu um erro.");
        this.hideLoading();
      });
    },

    removerHandler() {
      this.$confirm("Deseja remover esta Venda?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
       this.removerVendaSelecionada();
      });
    },   

    //FORMULARIOS
    selecionarFormulario(formularioSelecionado) {
      if(formularioSelecionado.nomeArquivo !== undefined && formularioSelecionado.nomeArquivo !== null) {
        this.formularioSelecionado = formularioSelecionado;
      } else {
        this.formularioSelecionado = { perguntasFormulario: [] };
      }
    },
    gerarFormulario() {
      if(this.formularioSelecionado != null) {
        let payload = { id: this.formularioSelecionado.id };

        this.showLoading();
        this.recuperarPerguntasFormulario(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.finalizarGeracaoFormulario(resultado);
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro.");
        });
      }
    },
    finalizarGeracaoFormulario(resultado) {
      this.formularioSelecionado = resultado.item;
      this.formularioSelecionado["venda"] = this.venda;
      
      if(this.formularioSelecionado.perguntasFormulario !== undefined) {
        this.exibirDialogPerguntasFormulario();  
      } else {
        this.showLoading();
        this.gerarFormularioVenda(this.formularioSelecionado)
        .then(response => {
          window.open(response.mensagem, "_blank");
          this.hideLoading();
        }).catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
      }
    },

    removerDiretorioHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorio(diretorio);
      });
    },
    removerDiretorio(diretorio) {
      let payload = {
        id: diretorio.id,
        tipoFormularios: diretorio.tipoFormularios,
        idObjeto: this.venda.id
      };

      this.showLoading();
      this.removerDiretorioVenda(payload)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERROR":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      });
    },
    recuperarCliente(cliente) {
      let payload = { id: cliente.id };

      this.showLoading();
      this.recuperarClienteVenda(payload)
        .then(resultado => {
          this.hideLoading();
          if(resultado.status == "SUCESSO") {
            this.$router.push("/clientes");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Oops, this is a error message.");
          this.hideLoading();
        });
    },

    //COMISSÕES
    gerarReciboComissao() {
      let recibosPagosArray = new Array();
      this.comissaoSelecionada.pagamentosComissao.forEach(element => {
        if(element.status === "PAGO") {
          recibosPagosArray.push(element.id);
        }
      });

      if(recibosPagosArray.length == 0) {
        this.$message.warning("Não há recibo pago associado a esta comissão!");
        return;
      }

      let payload = recibosPagosArray;

      this.showLoading();
      this.gerarReciboComissaoPagos(payload)
      .then(resultado => {
        this.hideLoading();
        window.open(resultado.item, "_blank");
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
    },
    gerarListaComissoesCorretores() {
      let payload = {
        nome: "COMISSOES_VENDA",
        venda: {
          id: this.venda.id
        }
      };

      this.showLoading();
      this.gerarRelatorio(payload)
      .then(resultado => {
        this.hideLoading();
        if (resultado.status == "SUCESSO") {
          window.open(resultado.mensagem, "_blank");
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    gerarReciboComissaoCorretor() {
      let payload = {
        comissao: {
          id: this.historicoComissaoSelecionada.id
        }
      };

      this.showLoading();
      this.gerarReciboComissaoUnico(payload)
      .then(resultado => {
        this.hideLoading();
        window.open(resultado.item, "_blank");
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
    },
    cancelarHistoricoPagamentoComissaoHandler() {
      this.$confirm("Deseja cancelar o pagamento selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.cancelarHistoricoPagamentoComissao();
      });
    },
    cancelarHistoricoPagamentoComissao() {
      let payload = {
        id: this.historicoComissaoSelecionada.id
      };

      this.showLoading();
      this.cancelarPagamentoComissao(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.atualizarHistoricoPagamento();
              this.$message.success(resultado.mensagem);
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Ocorreu um erro.");
        });
    },
    removerHistoricoPagamentoComissaoHandler(scope) {
      this.$confirm("Deseja remover o pagamento selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerHistoricoPagamentoComissao(scope);
      });
    },
    removerHistoricoPagamentoComissao() {
      let payload = {
        id: this.historicoComissaoSelecionada.id,
        venda: { id: this.venda.id }
      };

      this.showLoading();
      this.removerPagamentoComissao(payload)
      .then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.atualizarHistoricoPagamento();
            this.$message.success(resultado.mensagem);
            break;
          default:
            this.$message.error(resultado.mensagem);
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
    },
    configurarDataGridComissoes() {
      let comissoesCorretor = new Array();

      if(this.permissoes.visualizacaoSomenteComissoesCorretor && this.venda.cliente.id !== 0 && this.venda.status === "APROVADO") {
        this.venda.comissoes.forEach(comissao => {
          comissoesCorretor.push(comissao);          
        });
        this.venda.comissoes = comissoesCorretor;
      }
    },
    configurarHistoricoPagamentoComissoes(){
      this.comissaoSelecionada = {
        corretor: {
          nome: ""
        }
      };
    },

    //ARQUIVOS
    exibirDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = true;
    },
    fecharDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = false;
    },
    exibirBotaoRemoverDiretorioArquivo(data) {
      return data.nome !== "Outros";
    },
    selecionarArquivo(arquivoSelecionado) {
      if(arquivoSelecionado !== undefined && arquivoSelecionado.descricao !== null) {
        this.arquivoSelecionado = arquivoSelecionado;
      }
    },
    labelPropriedades(key){
      switch (key) {
        case "usuario":
          return "Usuário";
        case "data":
          return "Envio";
        case "localizacaoFisica":
          return "Observações";    
        case "descricao":
          return "Nome";
        case "extensao":
          return "Extensão do Arquivo"  
        default:
          break;
      }
    },
    removerArquivosHandler(data){
      if(data.descricao){
        this.removerArquivoHandler(data)
      }else{
        this.removerDiretorioArquivosHandler(data)
      }
    },
    removerDiretorioArquivosHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorioArquivo(diretorio);
      });
    },
    removerDiretorioArquivo(diretorio) {
      let payload = { id: diretorio.id, idVenda: this.venda.id};

      this.showLoading();
      this.removerDiretorioArquivos(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    formatarLabelArquivo(arquivo) {
      if(arquivo.descricao != undefined){
        return "normal";
      }
      return "bold";
    },

    formatarIconeTreeArquivo(arquivo) {
      if(arquivo.descricao != undefined) {
        return 'el-icon-document'
      }
      return 'el-icon-folder-opened'
    },
    exibirDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = true;
    },
    fecharDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = false;
    },
    removerArquivoHandler(arquivo) {
      let payload = { id: arquivo.id };

      this.showLoading();
      this.removerArquivo(payload)
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERROR":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      });
    },

    downloadArquivoHandler(arquivo) {
      window.open(arquivo.path, "_blank");
    },

    //OBSERVACOES
    exibirObservacao(observacaoSelecionada) {
      this.observacaoSelecionada = observacaoSelecionada;
    },

    alterarObservacao(observacao, column) {
      if(column.columnKey == "acoes") { return }
      if(!this.permissoes.alterarObservacoes) { return }
      if(this.permissoes.alterarObservacoesSomenteCorretor && observacao.usuario.id !== this.usuarioLogado.id) { return }
      
      let payload = { id: observacao.id };

      this.showLoading();
      this.recuperarObservacaoVenda(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.observacaoEmEdicao = resultado.item;
            this.observacaoSelecionada = {};
            this.visibilidadeGravarObservacaoDialog = true;
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },

    removerObservacaoHandler(observacao) {
      let payload = { id: observacao.id };

      this.showLoading();
      this.removerObservacao(payload)
      .then(resultado => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.observacaoSelecionada = {};
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se com o servidor");
      });
    },

    gerarRelatorioObservacao() {
      let payload = { 
        nome: "OBSERVACOES_VENDA",
        venda: { id: this.venda.id }
      };

      this.showLoading();
      this.gerarRelatorio(payload)
      .then((response) => {
        this.hideLoading();
        switch(response.status) {
          case "SUCESSO":
            window.open(response.mensagem, '_blank');  
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },

    //DIALOGS
    exibirDialogAdicionarComissao(tipo) {
      if(tipo === "IMOBILIARIA") {
        this.comissaoImobiliaria = true;
      } else {
        this.comissaoImobiliaria = false;
      }

      this.visibilidadeDialogAdicionarComissao = true;
    },
    fecharDialogAdicionarComissao() {
      this.restanteComissoes();
      this.visibilidadeDialogAdicionarComissao = false;
      //this.atualizarHistoricoPagamento();
    },
    exibirDialogPagarComissao() {
      this.visibilidadeDialogPagarComissao = true;
    },
    fecharDialogPagarComissao() {
      this.visibilidadeDialogPagarComissao = false;
      this.atualizarHistoricoPagamento();
    },
    exibirDialogPagarComissaoCompleta() {
      this.visibilidadeDialogPagarComissaoCompleta = true;
    },
    fecharDialogPagarComissaoCompleta() {
      this.visibilidadeDialogPagarComissaoCompleta = false;
      this.atualizarHistoricoPagamento();
    },
    exibirDialogAdicionarPagamentoComissao() {
      this.visibilidadeDialogAdicionarPagamentoComissao = true;
    },
    fecharDialogAdicionarPagamentoComissao() {
      this.visibilidadeDialogAdicionarPagamentoComissao = false;
      this.atualizarHistoricoPagamento();
    },
    exibirDialogRemoverComissao() {
      this.visibilidadeDialogRemoverPagamentoComissao = true;
    },
    fecharDialogRemoverComissao() {
      this.restanteComissoes();
      this.visibilidadeDialogRemoverPagamentoComissao = false;
    },
    exibirDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = true;
    },
    fecharDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = false;
    },
    exibirDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = true;
    },
    fecharDialogCriarDiretorio() {
      this.visibilidadeCriarDiretorioDialog = false;
    },
    exibirDialogSelecionarDiretorio() {
      this.visibilidadeSelecionarDiretorioDialog = true;
    },
    fecharDialogSelecionarDiretorio() {
      this.visibilidadeSelecionarDiretorioDialog = false;
    },
    exibirDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = true;
    },
    fecharDialogPerguntasFormulario() {
      this.visibilidadePerguntasFormularioDialog = false;
    },
    exibirDialogGravarCliente() {
      this.visibilidadeGravarClienteDialog = true;
    },
    fecharDialogGravarCliente() {
      this.visibilidadeGravarClienteDialog = false;
    },
    exibirGravarObservacaoDialog() {
      this.observacaoEmEdicao = undefined
      this.visibilidadeGravarObservacaoDialog = true;
    },
    fecharGravarObservacaoDialog() {
      this.visibilidadeGravarObservacaoDialog = false;
    },

    //UTIL
    formatarSelectCliente(cliente){
      return Util.formatarSelectCliente(cliente);
    },
    formatarValor(valor) {
      return Util.formatarValor(valor);
    },
    formatarPercentual(percentual) {
      return Util.formatarPercentual(percentual);
    },
    formatarEnderecoImovel(imovel){
      return Util.formatarLabelImovel(imovel, ESTADOS);
    },
    coresPesquisa(status) {
      switch(status) {
        case "APROVADO":
          return "#2DB748";
        case "PENDENTE":
          return "#4B6EF6";
          case "CANCELADO":
          return "#DF1B1B";
      }
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
      this.restanteComissoes();
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload)
      .then(() => {
        this.loadingUsuarios = false;    
      }).catch(() => {
        this.loadingUsuarios = false;    
      });
    },
    filtrarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
      .then(() => {
        this.loadingClientes = false;
      }).catch(() => {
        this.loadingUsuarios = false;    
      });
    },
    filtrarImoveisSelect(queryString) {
      let payload = {
        operacao: "VENDA",
        status: "DISPONIVEL"
      };

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.endereco = queryString,

      this.loadingImoveis = true;
      this.listarImoveis(payload)
      .then(() => {
        this.loadingImoveis = false;
      }).catch(() => {
        this.loadingImoveis = false;
      });
    },
    formatarLabelPagamento(comissao) {
      return this.util.getLabel(this.statusPagamento, comissao.status);
    },
    formatarLabelCorretor(comissao) {
      return comissao.corretor === null ||
        comissao.corretor === undefined ||
        comissao.corretor.nome === null ||
        comissao.corretor.nome === undefined
        ? "IMOBILIÁRIA"
        : comissao.corretor.nome;
    },
    formatarLabelFormulario(formulario) {
      if(formulario.nomeArquivo != undefined){
        return 'normal';
      }
      return 'bold';
    },
    formatarIconeTree(formulario) {
      if(formulario.nomeArquivo != undefined) {
        return 'el-icon-document'
      }
      return 'el-icon-folder-opened'
    },
    formatarLabelValor(item) {
      return this.formatarValor(item.valor);
    },
    formatarLabelValorEmAberto(item) {
      return this.formatarValor(item.valorEmAberto);
    },
    formatarLabelValorPago(item) {
      return this.formatarValor(item.valorPago);
    },
    formatarLabelPercentual(item) {
      return item.percentual + '%';
    },

    validarSeparadorDecimal(event) {
      const textoDigitado = event.target.value;
      
      const textoComVirgulasTratadas = this.substituirTodaVirgulaPorPonto(textoDigitado);
      const textoComPontosTratados = this.removerTodosOsPontosDepoisDoPrimeiro(textoComVirgulasTratadas);

      const textoFinal = textoComPontosTratados;

      event.target.value = textoFinal;
    },

    validarInputNumerico(event) {
      const valorDigitado = event.key;
      const valoresPermitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];
      const valorNaoEhPermitido = !valoresPermitidos.includes(valorDigitado);

      if(valorNaoEhPermitido) event.preventDefault();
    },

    substituirTodaVirgulaPorPonto(texto) {
      return texto.replace(/,/g, '.');
    },
    removerTodosOsPontosDepoisDoPrimeiro(texto) {
      return texto.replace(/(?<=\..*)\./g, '');
    },

    tabClicked(tab) {
      if(tab.name === "logs") {
        this.handleRecuperarLogs();
      }

      if (tab.name === "formularios") {
        this.handleRecuperarFormularios();
      }
    },

    handleRecuperarLogs() {
      const payload = { venda: { id: this.venda.id }, pagina: -1 };
      this.showLoading();

      this.recuperarLogs(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    handleRecuperarFormularios() {
      const payload = { tipo: "VENDA" };
      this.showLoading();

      this.recuperarFormularios(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    exibirHistoricoPagamento(comissaoSelecionada) {
      this.comissaoSelecionada = comissaoSelecionada;
      this.historicoComissaoSelecionada = {
        corretor: {
          nome: ""
        }        
      };
    },
    atualizarHistoricoPagamento() {
      this.exibirHistoricoPagamento(this.venda.comissoes.filter((comissao) => { return comissao.id == this.comissaoSelecionada.id })[0])
    },    
    selecionarHistoricoComissao(historicoComissao) {
      this.historicoComissaoSelecionada = historicoComissao;
    },
    calcularValorComissao() {
      let totalVenda = this.venda.valor;
      
      const novaComissao = ((totalVenda * this.venda.comissao)/100).toFixed(2);
      if(isNaN(novaComissao)) {
        this.venda.valorComissao = 0;
      } else {
        this.venda.valorComissao = novaComissao;
      }
        
      // this.venda.valorComissao = parseFloat(new BigDecimal(totalVenda)
      //   .multiply(new BigDecimal(this.venda.comissao))
      //   .divide(new BigDecimal(100))
      //   .round(2, BigDecimal.RoundingModes.HALF_UP)
      //   .getValue());

      this.restanteComissoes();
    },
    calcularComissao() {
      let valorVenda = this.venda.valor;
      
      if(valorVenda == 0) {
        this.venda.comissao = 0;
      } else {
        const novaComissao = ((this.venda.valorComissao*100)/valorVenda).toFixed(2);
        // this.venda.comissao = parseFloat(new BigDecimal(this.venda.valorComissao)
        //   .multiply(new BigDecimal(100))
        //   .round(10, BigDecimal.RoundingModes.HALF_UP)
        //   .divide(new BigDecimal(valorVenda))
        //   .round(10, BigDecimal.RoundingModes.HALF_UP)
        //   .round(2, BigDecimal.RoundingModes.HALF_UP)
        //   .getValue());
        if(isNaN(novaComissao)) {
          this.venda.comissao = 0;
        } else {
          this.venda.comissao = novaComissao;
        }
      }

      this.restanteComissoes();
    },
    restanteComissoes() {
      const comissao = isNaN(this.venda.valorComissao) ? 0 : this.venda.valorComissao;
      var valorComissao = new BigDecimal(comissao).subtract(new BigDecimal(this.venda.valorImpostoComissao));
      if (valorComissao.compareTo(new BigDecimal(0)) > 0) {
        this.percentualRestante = valorComissao
          .subtract(
            new BigDecimal(this.somarComissoes()).round(
              10,
              BigDecimal.RoundingModes.HALF_UP
            )
          )
          .divide(valorComissao.round(10, BigDecimal.RoundingModes.HALF_UP))
          .multiply(new BigDecimal(100))
          .round(2, BigDecimal.RoundingModes.HALF_UP)
          .getValue();
      }

      this.comissaoRestante = valorComissao
        .subtract(new BigDecimal(this.somarComissoes()))
        .round(2, BigDecimal.RoundingModes.HALF_UP)
        .getValue();
    },
    somarComissoes() {
      let somatorio = new BigDecimal(0);
      this.venda.comissoes.forEach(comissao => {
        somatorio = somatorio.add(new BigDecimal(comissao.valor));
      });

      return somatorio.getValue();
    },
    configurarCampoCorretor() {
      this.venda.usuario = this.usuarioLogado;

      const usuarioLogadoNotInUsuariosDisponiveis = !this.usuariosDisponiveis.map(usuario => usuario.id)
        .includes(this.usuarioLogado.id);

      if(usuarioLogadoNotInUsuariosDisponiveis) {
        this.usuariosDisponiveis.push(this.usuarioLogado);
      }
    },
    atualizarValores(){
      if(this.venda.imovel){
        this.venda.valor = this.venda.imovel.valor;
        this.venda.comissao = this.venda.imovel.comissao;
      }
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    limpar() {
      this.$refs["formVenda"].resetFields();
    },
    enviar(){
      if(this.dadosPesquisaVenda){
        this.pesquisar();
      }
    },

    filtrarObservacoes(observacao) {
      const descricao = observacao.descricao !== null ? Util.removerAcentos(observacao.descricao.trim().toLowerCase()) : '';
      const assunto = observacao.assunto !== null ? Util.removerAcentos(observacao.assunto.trim().toLowerCase()) : '';
      
      const searchTerm = Util.removerAcentos(this.filtroObservacoes.trim().toLowerCase());

      return descricao.includes(searchTerm) || assunto.includes(searchTerm);
    },

    formatarLinha1EnderecoImovel(imovel) {
      let texto = Util.formatarLinha1EnderecoImovel(imovel);
      if(imovel.complemento && imovel.complemento.trim() !== '' ) {
        texto += ' - ' + imovel.complemento;
      }

      return texto;
    },
    labelInfo(item){
      return item.contaBancaria ? Util.getLabel(BANCOS, item.contaBancaria.banco) : ''
    },

    labelContrato(venda){
      return (venda === undefined || venda.id === 0 ? "Nova Venda" : this.util.formatarEnderecoImovelContrato(venda))
    },
    irParaSecao(){
      location.href = '#novo'
    },
    //BOTOES MOBILE
    retrairBotoes(){
      this.hoverGravar = false
      this.hoverDesaprovar = false
      this.hoverAprovar = false 
      this.hoverRemover = false
      this.hoverRestaurar = false
      this.hoverCancelar = false
    },
    expandGravar(){
      this.retrairBotoes();
      this.hoverGravar = !this.hoverGravar
    },
    expandDesaprovar(){
      this.retrairBotoes();
      this.hoverDesaprovar = !this.hoverDesaprovar
    },
    expandAprovar(){
      this.retrairBotoes();
      this.hoverAprovar = !this.hoverAprovar
    },
    expandRemover(){
      this.retrairBotoes();
      this.hoverRemover = !this.hoverRemover
    },
    expandCancelar(){
      this.retrairBotoes();
      this.hoverCancelar = !this.hoverCancelar
    },
    expandRestaurar(){
      this.retrairBotoes();
      this.hoverRestaurar = !this.hoverRestaurar
    },
  } 
};